function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import get from 'lodash/get';
import map from 'lodash/map';
import flatMap from 'lodash/flatMap';
import values from 'lodash/values';
import mapValues from 'lodash/mapValues';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import includes from 'lodash/includes';
import every from 'lodash/every';
import some from 'lodash/some';
import zipObject from 'lodash/zipObject';
import { mapState, mapGetters } from 'vuex';
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    show: {
      type: Array,
      required: true
    },
    frequency_group_values: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapState({
    elementType: function elementType(s) {
      return s.api.query.elements.type;
    },
    elementGroups: function elementGroups(s) {
      return s.api.query.groups;
    },
    reference: function reference(s) {
      return s.api.result.reference;
    },
    full_reference: function full_reference(s) {
      return s.api.result.full_reference;
    }
  }), {}, mapGetters('filters', ['exists']), {
    elements: function elements() {
      return {
        left: map(this.row.groups.left, function (e) {
          return mapValues(e, function (v) {
            return {
              value: v
            };
          });
        }),
        right: map(this.row.groups.right, function (e) {
          return mapValues(e, function (v) {
            return {
              value: v
            };
          });
        }),
        escape: true,
        merge: true
      };
    },
    hasNullGroups: function hasNullGroups() {
      var valuesLeft = flatMap(this.row.groups.left, values);
      var valuesRight = flatMap(this.row.groups.right, values);
      return some(valuesLeft, isNil) || some(valuesRight, isNil);
    },
    hasSpecificGroupLink: function hasSpecificGroupLink() {
      return !this.hasNullGroups && !isEqual(this.elementGroups, this.$ncsConfig.result.matching_expressions[this.elementType].groups);
    },
    hasKwicLink: function hasKwicLink() {
      return !this.hasNullGroups && this.row.elements && this.row.elements > 0;
    },
    showFrequencyNumber: function showFrequencyNumber() {
      var _this = this;

      var reference = this.normalizeFrequency(this.row.elements, this.reference.elements_reference);
      var frequencies = this.show.map(function (e) {
        return e === 'frequency' ? _this.$fn(_this.row.elements) : reference;
      }).join(' | ');
      return "".concat(frequencies, " / ").concat(this.$fn(this.row.documents));
    },
    showCellTitle: function showCellTitle() {
      return ["".concat(this.$t('result.matching_expressions.cell_frequency.elements'), ": ").concat(this.$fn(this.row.elements)), "".concat(this.$t('result.matching_expressions.cell_frequency.normalized'), ": ").concat(this.normalizeFrequency(this.row.elements, this.reference.elements_reference)), "".concat(this.$t('result.matching_expressions.cell_frequency.documents'), ": ").concat(this.$fn(this.row.documents))].map(function (s) {
        return s.replace(/&nbsp;/g, ' ');
      }).join('\n');
    }
  }),
  methods: {
    filterIds: function filterIds(group) {
      var groups = this.$ncsConfig.result.matching_expressions.groups;
      return groups[group] && groups[group].filters || [group];
    },
    filterValues: function filterValues(group, value) {
      var groups = this.$ncsConfig.result.matching_expressions.groups;

      var getValues = groups[group] && groups[group].getValues || function (e) {
        return [e];
      };

      return getValues(value);
    },
    frequencyElements: function frequencyElements(group, value) {
      return get(this.row.frequencies, [group, value, 'elements'], 0);
    },
    normalizeFrequency: function normalizeFrequency(elements, reference) {
      // First case can only happen when there is one group value that only matches documents with no elements
      var normalized = elements === 0 && reference === 0 ? 0 : Math.round(elements * 1000000 / reference);
      return this.$fn(normalized);
    },
    showFrequencyGroupNumber: function showFrequencyGroupNumber(group, value) {
      var _this2 = this;

      var cell = this.row.frequencies[group][value];
      var reference = this.normalizeFrequency(cell.elements, this.full_reference[group][value].elements_reference);
      var frequencies = this.show.map(function (e) {
        return e === 'frequency' ? _this2.$fn(cell.elements) : reference;
      }).join(' | ');
      return "".concat(frequencies, " / ").concat(this.$fn(cell.documents));
    },
    showCellGroupTitle: function showCellGroupTitle(group, value) {
      var cell = this.row.frequencies[group][value];
      var reference = this.full_reference[group][value] || {
        elements_reference: 0,
        documents_reference: 0
      };
      return ["".concat(this.$tOr('result.matching_expressions.groups', "".concat(group, ".name"), group), ": ").concat(this.$tOr('result.matching_expressions.groups', "".concat(group, ".values.").concat(value), value)), "".concat(this.$t('result.matching_expressions.cell_frequency.elements'), ": ").concat(this.$fn(cell.elements), " / ").concat(this.$fn(reference.elements_reference)), "".concat(this.$t('result.matching_expressions.cell_frequency.normalized'), ": ").concat(this.normalizeFrequency(cell.elements, reference.elements_reference)), "".concat(this.$t('result.matching_expressions.cell_frequency.documents'), ": ").concat(this.$fn(cell.documents), " / ").concat(this.$fn(reference.documents_reference))].map(function (s) {
        return s.replace(/&nbsp;/g, ' ');
      }).join('\n');
    },
    hasGroupKwicLink: function hasGroupKwicLink(group, value) {
      var _this3 = this;

      var notEmptyFrequencies = this.row.frequencies[group][value] && this.row.frequencies[group][value].elements > 0;
      var filterExist = every(this.filterIds(group), function (f) {
        return _this3.exists(f);
      });
      return !this.hasNullGroups && filterExist && notEmptyFrequencies;
    },
    showKwic: function showKwic() {
      // When navigating to KWIC all sensitivity options MUST be enabled unless the only groups are category or tag.
      // When going to KWIC we set the clicked row values in the element section.
      // Since sensitivity is used for grouping, it has to be enabled in ths KWIC search to match the clicked row ones.
      // The exception is when the only groups used are category and tag, which are always case insensitive.
      // In this cases we MUST NOT change sensitivity to match the clicked row results.
      if (this.elementGroups.some(function (g) {
        return g !== 'tag' && g !== 'category';
      })) {
        this.$store.commit('elements/setAllGlobalOptions', true);
      }

      this.$store.commit('elements/setElements', this.elements);
      this.$store.dispatch('api/setResultType', 'kwic');
      this.$store.dispatch('pagination/changePage', 1);
    },
    showGroupKwic: function showGroupKwic(group, value) {
      var filter = zipObject(this.filterIds(group), this.filterValues(group, value));
      this.$store.commit('filters/setFilterIfMoreStrict', filter);
      this.showKwic(this.row);
    },
    showSpecificGroup: function showSpecificGroup() {
      this.$store.commit('elements/setElements', this.elements);
      this.$store.commit('groups/setGroups', this.$ncsConfig.result.matching_expressions[this.elementType].groups);
      this.$store.dispatch('pagination/changePage', 1);
    }
  }
};